import React from "react";
import { Link } from "react-router-dom";
import contact from "../../assets/contact.jpg";

const CTASection = ({ bgImage = contact }) => {
  return (
    <section
      className="relative py-24 bg-fixed bg-cover bg-center"
      style={{
        backgroundImage: `url(${contact})`,
        backgroundAttachment: "fixed",
      }}
    >
      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-[#2F3C7E]/80"></div>

      {/* Content */}
      <div className="container mx-auto px-4 relative z-10">
        <div className="flex flex-col md:flex-row items-center justify-between">
          {/* Left Column - Text */}
          <div className="w-full md:w-3/4 text-center md:text-left mb-6 md:mb-0">
            <h5 className="text-xl md:text-2xl lg:text-3xl font-bold text-white">
              Discover a Customized Hospitality Solution Today.
            </h5>
          </div>

          {/* Right Column - Button */}
          <div className="w-full md:w-1/4 text-center md:text-right">
            <Link to="/contact">
              <button className="bg-[#E6B325] text-[#2F3C7E] px-8 py-3 rounded-lg font-semibold hover:bg-[#c99a1a] transition shadow-lg hover:shadow-xl transform hover:-translate-y-1">
                Contact Now
              </button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;

